module.exports = __webpack_public_path__ + "resources/img/main11.99ef0a5f0e8765a7c4360f267bd95d46.png";